import { LicenseManager } from 'ag-grid-enterprise';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { APP_ENV } from 'adapters/constants';
import { HarnessFlagProvider } from 'components/HarnessProvider';
import { URLsProvider } from 'hooks';
import { Client } from './adapters';
import App from './App';
import {
  AG_GRID_LICENSE,
  NodeEnvironments,
  ReactEnvironments
} from './common/constants';
import worker from './mocks/browser';
import OktaSecureWrapper from './OktaSecureWrapper';
import reportWebVitals from './reportWebVitals';

import './index.css';

LicenseManager.setLicenseKey(AG_GRID_LICENSE);

const renderApplication = async () => {
  if (
    process.env.REACT_APP_MSW_FLAG === 'on' &&
    (process.env.NODE_ENV === NodeEnvironments.Development ||
      APP_ENV === ReactEnvironments.Develop)
  ) {
    await worker.start();
  }

  window.browserWorker = worker;

  const container = document.getElementById('root') as Element;
  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <HarnessFlagProvider>
        <App client={Client}>
          <URLsProvider>
            <OktaSecureWrapper />
          </URLsProvider>
        </App>
      </HarnessFlagProvider>
    </React.StrictMode>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
renderApplication().catch(e => /* eslint-disable no-console */ console.log(e));
